import React from "react";
import "./HomeSocialMedia.css";

const WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor">
        <path d="M12.031 2C6.505 2 2.016 6.489 2.016 12.015c0 1.764.46 3.488 1.334 5.002L2 22l5.127-1.345a9.98 9.98 0 0 0 4.904 1.282h.004c5.526 0 10.016-4.49 10.016-10.016A10.02 10.02 0 0 0 12.031 2zm5.845 14.175c-.244.686-1.42 1.31-1.956 1.393-.537.082-1.226.115-1.977-.128a17.2 17.2 0 0 1-5.328-3.328 12.63 12.63 0 0 1-2.613-3.256c-.29-.495-.584-1.313-.027-1.87.273-.273.612-.686.918-.992.306-.306.408-.52.612-.867.204-.347.102-.653-.051-.96-.153-.306-1.378-3.318-1.889-4.544-.497-1.196-1.002-1.034-1.378-1.054-.356-.02-.765-.02-1.173-.02-.408 0-1.071.153-1.632.765-.561.612-2.143 2.092-2.143 5.102s2.194 5.918 2.5 6.326c.306.408 4.316 6.592 10.459 9.245 1.46.63 2.6 1.008 3.49 1.291 1.468.467 2.805.401 3.86.244 1.177-.175 3.622-1.48 4.133-2.908.51-1.428.51-2.653.357-2.908-.153-.255-.561-.408-1.173-.714z" />
    </svg>
);

const InstagramIcon = () => (
    <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
);

const FacebookIcon = () => (
    <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
);

const XIcon = () => (
    <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const HomeSocialMedia = () => {
    return (
        <section className="home-social">
            <div className="home-social-container">
                <h2>Follow Salar social media official accounts</h2>

                <div className="home-social-icons">
                    <button
                        type="button"
                        className="home-social-icon"
                        aria-label="WhatsApp"
                    >
                        <WhatsAppIcon />
                    </button>

                    <button
                        type="button"
                        className="home-social-icon"
                        aria-label="Instagram"
                    >
                        <InstagramIcon />
                    </button>

                    <button
                        type="button"
                        className="home-social-icon"
                        aria-label="Facebook"
                    >
                        <FacebookIcon />
                    </button>

                    <button
                        type="button"
                        className="home-social-icon"
                        aria-label="X"
                    >
                        <XIcon />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default HomeSocialMedia;